
import request from "@/utils/request";


export function certificateQuery(param) {
    return request({
        url: '/dev-api/evidence/certificateQuery?certificateNo='+param.certificateNo + "&hashValue=" + param.hashValue,
        headers: {
            isToken: false
        },
        method: 'get',

    })
}
export function  updateEvidence(data){
    return request({
        url:'/dev-api/evidence/',
        method:'PUT',
        data :data
    })
};

export function updateEvidenceReview(data) {
    return request({
        url: '/dev-api/evidence/updateReview',
        method: 'PUT',
        data: data
    })
}

export  function  download(id){
    return request({
        url:'/dev-api/evidence/download/'+id,
        method:'get'
    })
}

export  function  downloadExcel(id){
    return request({
        url:'/dev-api/download/excel',
        method:'get'
    })
}


export  function  selectMarket(){
    return request({
        url:'/dev-api/technologyMarket/selectMarket',
        method: 'get'
    })
}

export function batchUpdateSortNum(data) {
    return request({
        url: '/dev-api/evidence/batchUpdateSortNum',
        method: 'POST',
        data: data
    })
}

/** 重新生成证书（按存证提交时间 createTime 生成路径与二维码日期，审核通过记录） */
export function regenerateCertificate(id) {
    return request({
        url: '/dev-api/evidence/regenerateCertificateWithSubmitTime/' + id,
        method: 'post'
    })
}

/** 管理员补录专家/综合估值，已审核通过时自动重生成证书 */
export function updateValuation(data) {
    return request({
        url: '/dev-api/evidence/updateValuation',
        method: 'put',
        data: data
    })
}

/** 用户修改存证并重新提交审核 */
export function resubmitEvidence(data) {
    return request({
        url: '/dev-api/evidence/resubmit',
        method: 'put',
        data: data
    })
}

/** 查询成果平台审核记录 */
export function getEvidenceReviewLog(evidenceId) {
    return request({
        url: '/dev-api/evidence/reviewLog/' + evidenceId,
        method: 'get'
    })
}
